// extracted by mini-css-extract-plugin
export default {"addToCartControl":"B0-z","giftCard":"C0-z","btnContainer":"D0-z","cartButton":"E0-z","disabled":"F0-z"};